import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getApiEndpoint } from "../../utils/apiUrl";

export default function OAuthSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Vérifier s'il y a une erreur dans l'URL (venant du callback)
    const errorParam = searchParams.get('error');
    if (errorParam) {
      setError('Erreur lors de la connexion Google');
      setTimeout(() => navigate("/login"), 3000);
      return;
    }

    fetch(getApiEndpoint('/api/me'), {
      credentials: "include",
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(async (res) => {
        if (!res.ok) {
          const errorData = await res.json().catch(() => ({}));
          throw new Error(errorData.error || "Non authentifié");
        }
        return res.json();
      })
      .then((user) => {
        if (!user || !user.id) {
          throw new Error("Données utilisateur invalides");
        }
        
        console.log('✅ Utilisateur reçu de /api/me:', { id: user.id, email: user.email });
        
        // Stocker l'utilisateur dans localStorage
        localStorage.setItem("user", JSON.stringify(user));
        
        // Rediriger vers le dashboard
        window.location.href = "/admin/dashboard";
      })
      .catch((err) => {
        console.error('❌ Erreur lors de la récupération de l\'utilisateur:', err);
        setError(err.message || "Erreur de connexion");
        setTimeout(() => navigate("/login"), 3000);
      });
  }, [navigate, searchParams]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-600 mb-4">{error}</p>
          <p className="text-gray-600">Redirection vers la page de connexion...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Connexion Google en cours...</p>
      </div>
    </div>
  );
}
